import { useEffect, useState } from "react";
import { useDetailContext } from "../DetailContext";
import { ActionName, EventCallbackParamsType, MockupTextObject } from "../MockupEditor";
import GuideQuickTips from "../guide/GuideQuickTips";
import Media from "./Media";
import Shopify from "./Shopify";
import TText from "./Text";
import AIImage from "./AIImage";
import Stats from "libs/utils/stats";
import Product from "./Product";
import Product2_0 from "./Product2.0";
import { usePermissionContext } from "context/Permission";
import CustomImage from "components/common/CustomImage";


export default function EditorMeunBar(props: { onImageClick: Function}){

    // 左侧工具栏的选择类型，0为未选择 1开始
    const [toolType, setToolType] = useState<number>(1);
    // 编辑器模式： 1、图片模式  2、文本模式
    const [ editModel, setEditModel ] = useState<number>(1);
    const detailContext = useDetailContext();
    const permissionContext = usePermissionContext();

    const [ isShowQuickTips, setIsShowQuickTips ]= useState<boolean>(false);


    const buttonList = [{
        type: 1,
        image: '/icon/icon-editor-media.png',
        text: 'Media',
        isShow: true
    },{
        type: 6,
        image: '/icon/icon-editor-product-lib.png',
        text: 'Product',
        isShow: true,
    } ,{
        type: 7,
        image: '/icon/icon-editor-pattern.png',
        text: 'Pattern',
        isShow: true,
    },{
        type: 2,
        image: '/icon/icon-editor-text.png',
        text: 'Text',
        isShow: true
    },{
        type: 3,
        image: '/icon/icon-editor-t2i.png',
        text: 'Text-to-Image',
        isShow: true,
        isAi: false,
    } ,{
        type: 4,
        image: '/icon/icon-editor-i2i.png',
        text: 'Image-to-Image',
        isShow: true,
        isAi: false,
    },{
        type: 5,
        image: '/icon/icon-editor-shopify.png',
        text: 'Shopify product',
        isShow: permissionContext?.isShopify
    } ]

    // useEffect(() => {
    //     const link = document.createElement('link');
    //     link.href = Config.routePrefix + '/font-Inter.css'; // 字体 CSS 文件路径
    //     link.rel = 'stylesheet';
    //     document.head.appendChild(link);
    //     // 清理工作：在组件卸载时移除链接
    //     return () => {
    //         document.head.removeChild(link);
    //     };
    // }, []);


    // useEffect(() => { 
    //     if(toolType == 0) return ;
    //     console.info('toolType', toolType);
    //     // buttonList[toolType-1].isShow && detailContext?.triggerEditorAction({
    //     //     name: ActionName.SWITCH_EDITOR_MODE,
    //     //     params: `${toolType}`
    //     // })
    // },[ toolType ])

    // useEffect(() => {  
    //     const type = detailContext?.editorCallbackData?.type ;
    //     const data = detailContext?.editorCallbackData?.data ;
    //     switch(type){
    //         case EventCallbackParamsType.OBJECT_SELECT: // 对象选中
    //             // if(data.type == 3){
    //             //     setTextObject(data as MockupTextObject)
    //             // }else{
    //             //     setTextObject(undefined);
    //             // }
    //             break;
    //         case EventCallbackParamsType.OBJECT_CANCEL_SELECT: // 取消选中
    //             // setToolType((toolType: number) => {
    //             //     return toolType == 2 ? 0 : toolType ;
    //             // }); 
    //             // setTextObject(undefined);
    //             break;

    //     }
    // },[detailContext?.editorCallbackData])

    useEffect(() => {  
        if(isShowQuickTips) Stats.google('Tips');
    },[isShowQuickTips])

    const onToolTypeUpdateCallback = (toolType: number) => {
        setToolType(toolType);
    }

    const changeMediaType = (type: number) => {
        setToolType(toolType == type && type != 2 ? 0 : type);

        if(type == 1) Stats.google('Media');
        else if(type == 2) Stats.google('Text');
        else if(type == 3) Stats.google('Text to image');
        else if(type == 4) Stats.google('Image to image');
        else if(type == 5) Stats.google('Shopify product');
        else if(type == 6) Stats.google('Product lib');
        else if(type == 7) Stats.google('Pattern');
    }


    return (
        <div className="relative flex flex-none flex-col gap-[10px] items-center xl:w-[100px] xl:p-[15px] w-[70px] p-[5px] ">
            {
                buttonList.map((item) => (
                    item.isShow && <div key={item.text} className={`relative flex flex-col items-center justify-center w-full py-[8px] xl:py-[10px] rounded-[5px] xl:rounded-[10px] cursor-pointer ${toolType == item.type ? ' bg-[#D9F2FF]' : ''}`}
                        onClick={() => changeMediaType(item.type)}>
                        <CustomImage src={item.image} className="xl:w-[24px] w-[20px]" />
                        <span className="text-center leading-[14px] mt-[3px]">{item.text}</span>
                        {
                            item.isAi &&
                            <CustomImage src="/icon/icon-ai-jb.png" className="absolute left-0 top-0 w-[30px] h-[30px]" />
                        }
                    </div>
                ))
            }
            <div className={`absolute left-[10px] bottom-[10px] xl:bottom-[20px] hover:bg-[#D9F2FF] ${isShowQuickTips ? 'bg-[#D9F2FF]' : ''} rounded-[50%] cursor-pointer shadow-[15px_15px_30px_0px_rgba(0,0,0,0.25)]`}
                onClick={() => setIsShowQuickTips(!isShowQuickTips)}>
                <CustomImage src="/icon/icon-guide-quick-tips.png" className="w-[50px] xl:w-[70px]"/>
            </div>
            {
                toolType == 1 && <Media onImageClick={props.onImageClick} />
            }
            {
                <TText isTextMode={toolType == 2} onToolTypeUpdateCallback={onToolTypeUpdateCallback} />
            }     
            {
                toolType == 3 && <AIImage onImageClick={props.onImageClick} />
            }
            {
                toolType == 4 && <AIImage isImage={true} onImageClick={props.onImageClick} />
            }
            {
                toolType == 5 && <Shopify onImageClick={props.onImageClick} />
            } 
            {
                toolType == 6 && <Product2_0 onImageClick={props.onImageClick} />
            } 
            {
                toolType == 7 && <Product onImageClick={props.onImageClick} type={2} />
            } 
            {
                isShowQuickTips && <GuideQuickTips className="left-[40px] bottom-[60px] xl:left-[64px] xl:bottom-[90px] shadow-box" 
                    onCancel={() => setIsShowQuickTips(false)}/>
            }
        </div>
    )
}


